import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

/**
 *
 * @param project called when the observed value is not null
 * @returns Observable<Tout | null>
 */
export function nullOrSwitchMap<TIn, TOut>(project: (value: TIn) => Observable<TOut>) {
  return (observable: Observable<TIn | null | undefined>) =>
    observable.pipe(
      switchMap((r) =>
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        r == null ? of(null as null) : project(r!),
      ),
    );
}

/**
 *
 * @param project called when the observed value is not null
 * @returns Observable<Tout | null>
 */
export function undefinedOrSwitchMap<TIn, TOut>(project: (value: TIn) => Observable<TOut>) {
  return (observable: Observable<TIn | null | undefined>) =>
    observable.pipe(
      switchMap((r) =>
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        r == null ? of(undefined as undefined) : project(r!),
      ),
    );
}
